import { useTranslation } from 'react-i18next'

export type Language = 'es' | 'en' | 'pt'

export interface UseLanguageReturn {
  language: Language
  changeLanguage: (lang: Language) => Promise<void>
  isReady: boolean
}

/**
 * Hook para gestionar el idioma de la aplicación
 */
export function useLanguage(): UseLanguageReturn {
  const { i18n } = useTranslation()

  const changeLanguage = async (lang: Language) => {
    await i18n.changeLanguage(lang)
    // Guardar preferencia en localStorage
    localStorage.setItem('i18nextLng', lang)
  }

  return {
    language: i18n.language as Language,
    changeLanguage,
    isReady: i18n.isInitialized
  }
}
